import { useTranslation } from '@frontend/i18n';
import { settingsTrackingIds } from '@frontend/schedule-helpers';
import { SettingsLink, useSettingsNavigate } from '@frontend/settings-routing';
import { SettingsGroup } from '@frontend/settings-ui';
import { IndexRow, Text } from '@frontend/design-system';
import { useSchedulingLocationInfo } from '../../hooks/use-scheduling-location-info';

export const MultiLocationServiceTypes = () => {
  const { navigate } = useSettingsNavigate();
  const { t } = useTranslation('schedule-settings');
  const { selectedLocationIds, getScopeName } = useSchedulingLocationInfo();

  const navigateTo = (locationId: string) => {
    const route = '/schedule/services/:locationId';

    navigate({
      to: route,
      params: { locationId: locationId ?? '' },
    });
  };

  return (
    <SettingsGroup title={t('Location Settings')}>
      <IndexRow>
        {selectedLocationIds?.map((locationId) => (
          <IndexRow.Item
            key={locationId}
            as={SettingsLink}
            to='/schedule/services/:locationId'
            onClick={() => navigateTo(locationId)}
            trackingId={settingsTrackingIds.serviceTypesLocationRowItem}
          >
            <IndexRow.Item.Title>
              <div css={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Text>{getScopeName(locationId)}</Text>
              </div>
            </IndexRow.Item.Title>
          </IndexRow.Item>
        ))}
      </IndexRow>
    </SettingsGroup>
  );
};
